import Holidays from 'date-holidays'
import { INDEXED_ALL_EVENTS } from '@/consts/events'
import { APP_HOLIDAY_DEFAULT_LOCALE } from '@/consts/app'

const hd = new Holidays()
hd.setLanguages(APP_HOLIDAY_DEFAULT_LOCALE)

export default {
  /**
   * Retourne tous les mails exploitables dans l'appli
   * @param state
   * @param getters
   */
  emails: (state, getters) => {
    return _.uniqBy([
      ...getters['user/agency/customersEmails'],
      ...getters['user/agency/customersContactEmails'],
      ...getters['user/agency/agentsEmails']
    ].filter((e) => e.email), 'email')
  },

  /**
   * Calcule les servicesEvents personnalisés / globaux
   * @returns {{}}
   */
  constServiceEventTypesKeys: (state, getters) => {
    const o = {}
    const indexedCmpSrvEvt = getters['user/indexedCmpSrvEvt']
    state.CONSTS.serviceEventTypes.forEach((t) => {
      o[t.typeKey] = {
        ...(INDEXED_ALL_EVENTS[t.typeKey] || {}), // TODO Mettre en bdd
        ...t,
        enabled: false,
        root: true,
        subTypes: []
      }
      t.subTypes.forEach(({ id, ...subType }) => {
        if (o[subType.typeKey]) {
          throw new Error('ServiceEventType Exception : ' + subType.typeKey + ' éxiste déjà')
        }
        o[subType.typeKey] = {
          enabled: true, // Tous les évents actifs par défaut
          ...(INDEXED_ALL_EVENTS[subType.typeKey] || {}), // TODO Mettre en bdd
          ...(indexedCmpSrvEvt[id] || subType),
          id
        }
        o[t.typeKey].subTypes.push(o[subType.typeKey])
        if (o[subType.typeKey].enabled) {
          o[t.typeKey].enabled = true
        }
      })
    })
    return o
  },
  /**
   *
   * @param state
   * @param getters
   * @returns {function(*=): Array}
   */
  filterConstServiceEventTypes: (state, getters) => (keys = []) => {
    return _.filter(getters.constServiceEventTypesKeys, (t) => keys.length ? keys.includes(t.typeKey) : true)
  },
  /**
   * Calcule les locales disponibles pour les vacances (client / server)
   */
  constAvailableHolidaysProviders: (state) => {
    const locales = []
    const countries = _.sortBy(
      _.map(hd.getCountries(APP_HOLIDAY_DEFAULT_LOCALE), (label, value) => ({
        value,
        label,
        group: true,
        disable: state.CONSTS.availableHolidaysProviders[value] !== true
      })),
      'label'
    )
    countries.forEach((country) => {
      if (!country.disable) {
        locales.push(country)
        const states = hd.getStates(country.value, APP_HOLIDAY_DEFAULT_LOCALE)
        if (states) {
          locales.push(
            ..._.sortBy(
              _.map(
                states,
                (label, key) => {
                  const value = [country.value, key].join('-')
                  return {
                    value,
                    label,
                    caption: country.label,
                    disable: state.CONSTS.availableHolidaysProviders[value] !== true,
                    country
                  }
                }
              ).filter((s) => !s.disable),
              'label'
            )
          )
        }
      }
    })
    return locales
  },

  /**
   * Détermine si un eventType est restreint par l'appli
   * @param state
   * @returns {function(*=): boolean}
   */
  isRestrictedEventType: (state) =>
    (eventType) => state.CONSTS.serviceEventTypesRestricted.indexOf(
      _.isObject(eventType)
        ? _.get(eventType, ['type', 'typeKey'])
        : eventType) !== -1
}
